"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchedInfoStatus = exports.PricingType = exports.DiscountType = exports.TicketConfigStatus = exports.TicketStatus = exports.EventStatus = exports.NftDropFilter = exports.MyEventsEventDateFilter = void 0;
var MyEventsEventDateFilter;
(function (MyEventsEventDateFilter) {
    MyEventsEventDateFilter["Future"] = "future";
    MyEventsEventDateFilter["Past"] = "past";
    MyEventsEventDateFilter["All"] = "all";
})(MyEventsEventDateFilter || (exports.MyEventsEventDateFilter = MyEventsEventDateFilter = {}));
class NftDropFilter {
}
exports.NftDropFilter = NftDropFilter;
var EventStatus;
(function (EventStatus) {
    EventStatus["Draft"] = "draft";
    EventStatus["Committed"] = "committed";
    EventStatus["Published"] = "published";
    EventStatus["Updated"] = "updated";
    EventStatus["Canceled"] = "canceled";
})(EventStatus || (exports.EventStatus = EventStatus = {}));
var TicketStatus;
(function (TicketStatus) {
    // Created tickets
    TicketStatus["Draft"] = "draft";
    // Tickets after publishing to blockchain
    TicketStatus["Available"] = "available";
    // When associated with an order/ about to be issued
    TicketStatus["Reserved"] = "reserved";
    // When a payment is done or issue is called
    TicketStatus["Confirmed"] = "confirmed";
    // After they are assigned to the owner on the blockchain
    TicketStatus["Issued"] = "issued";
    // Activated through the wallet
    TicketStatus["Activated"] = "activated";
    // Used
    TicketStatus["Invalidated"] = "invalidated";
    // Event was canceled
    TicketStatus["Unavailable"] = "unavailable";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var TicketConfigStatus;
(function (TicketConfigStatus) {
    TicketConfigStatus["Draft"] = "draft";
    TicketConfigStatus["Updated"] = "updated";
    TicketConfigStatus["Committed"] = "committed";
    TicketConfigStatus["Published"] = "published";
})(TicketConfigStatus || (exports.TicketConfigStatus = TicketConfigStatus = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["Amount"] = "amount";
    DiscountType["Percent"] = "percent";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var PricingType;
(function (PricingType) {
    PricingType["Paid"] = "paid";
    PricingType["Free"] = "free";
    PricingType["Donation"] = "donation";
})(PricingType || (exports.PricingType = PricingType = {}));
var DispatchedInfoStatus;
(function (DispatchedInfoStatus) {
    DispatchedInfoStatus[DispatchedInfoStatus["Draft"] = 1] = "Draft";
    DispatchedInfoStatus[DispatchedInfoStatus["Sent"] = 2] = "Sent";
    DispatchedInfoStatus[DispatchedInfoStatus["Delivered"] = 3] = "Delivered";
})(DispatchedInfoStatus || (exports.DispatchedInfoStatus = DispatchedInfoStatus = {}));
//# sourceMappingURL=types.js.map